import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

import Spinner from '../common/spinner';
import { LoadingHolder, MiddleBox, LoadingText } from './LoadingComponent.styles';

class Loading extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    delay: PropTypes.number,
    marginTop: PropTypes.string,
  };

  static defaultProps = {
    label: 'Loading',
    delay: 1000,
  };

  state = {
    delay: true,
  };

  timeout = '';

  componentDidMount() {
    // Loading spinner will be shown after 1 sec delay
    this.timeout = setTimeout(() => this.setState({ delay: false }), this.props.delay);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  render() {
    const { marginTop } = this.props;

    return (
      <LoadingHolder hide={this.state.delay}>
        <MiddleBox marginTop={marginTop}>
          <Spinner size={30} />
          <LoadingText>{this.props.label}</LoadingText>
        </MiddleBox>
      </LoadingHolder>
    );
  }
}

export default Loading;

export const LoadingWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
